import * as React from "react";
import {
    WithStyles,
    withStyles,
    StyleRulesCallback
} from "@material-ui/core/styles";

// @ts-ignore
import whoops_IMG from "../../assets/images/expired.png";
import HeaderContainer from "../../components/Header/HeaderContainer";

interface IProps {}

const styles: StyleRulesCallback = () => ({
    pageContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5FAFC"
    },
    container: {
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        textAlign: "center"
    },
    imgContainer: {
        height: "13em",
        width: "13em",
        margin: "auto"
    },
    headerContainer: {
        marginTop: "1.3em",
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: 1.5,
        color: "#2F3033"
    },
    subHeaderContainer: {
        marginTop: "1em",
        marginBottom: "1em",
        fontSize: 15,
        fontWeight: 400,
        lineHeight: 1.5
    },
    btnContainer: {
        backgroundColor: "#305cc6",
        cursor: "pointer",
        borderRadius: "10px",
        width: "70%",
        margin: "auto",
        padding: "1em",
        marginTop: ".9em",
        "&:hover": {
            backgroundColor: "#234baa",

        }
    },
    linkContainer: {
        color: "white!important",
        fontWeight: 600,
        textDecoration: "none"
    }
});

@(withStyles(styles) as any)
export class ExpiredOfferScreen extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
    public memberClickDisabled = () => {
        return false;
    }

    public render() {
        const { classes } = this.props;
        return (
            <div className={classes!.pageContainer}>
                <HeaderContainer onAddMemberClicked={this.memberClickDisabled} showSignIn={false}/>
                <div className={classes!.container}>
                    <img className={classes!.imgContainer} src={whoops_IMG}/>
                    <div className={classes!.headerContainer}>
                        <div className={classes!.textHeader}>Your request has timed out</div>
                    </div>
                    <div className={classes!.subHeaderContainer}>
                        <div>Contact support for further assistance.</div>
                    </div>
                    <a className={classes!.linkContainer} href={"mailto:support@salaryo.com"}><div className={classes!.btnContainer}>Email Support</div></a>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/static/ExpiredOfferScreen.tsx